'use client';

import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.3, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: 'easeOut' },
  },
};

export default function HeroSection() {
  return (
    <motion.section
      id="hero"
      className="relative min-h-screen flex items-center justify-center text-center"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="z-10">
        <motion.h1
          className="text-5xl md:text-7xl font-bold tracking-tighter text-white"
          variants={itemVariants}
        >
          Osaze Okunbo
        </motion.h1>
        <motion.h2
          className="text-xl md:text-2xl mt-4 font-semibold text-text-secondary"
          variants={itemVariants}
        >
          Associate Product Manager, Operations & Automation
        </motion.h2>
        <motion.p
          className="max-w-2xl mt-6 text-lg text-text-primary leading-relaxed"
          variants={itemVariants}
        >
          I map messy workflows, define requirements, and ship AI-assisted tools that automate operations, accelerate sales, and turn business bottlenecks into measurable product outcomes.
        </motion.p>
      </div>
    </motion.section>
  );
}
